import loadable from '@loadable/component';

export const NewbuildingBrokerFlatCallbackModalContainerLoadable = loadable(
  () =>
    import('./NewbuildingBrokerFlatCallbackModalContainer').catch(
      /* istanbul ignore next */ () => ({ NewbuildingBrokerFlatCallbackModalContainer: () => null }),
    ),
  {
    resolveComponent: ({ NewbuildingBrokerFlatCallbackModalContainer }) => NewbuildingBrokerFlatCallbackModalContainer,
    ssr: false,
  },
);
